const e = {
  name: "Keypad",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3,40c-1.7,0-3-1.3-3-3V3c0-1.7,1.3-3,3-3h34c1.7,0,3,1.3,3,3v34c0,1.7-1.3,3-3,3H3z M2,3v6.5h7.5V2H3
			C2.5,2,2,2.5,2,3z M2,11.5V19h7.5v-7.5H2z M2,28.5h7.5V21H2V28.5z M2,30.5V37c0,0.5,0.5,1,1,1h6.5v-7.5H2z M11.5,30.5V38H19v-7.5
			H11.5z M21,30.5V38h7.5v-7.5H21z M28.5,28.5V21H21v7.5H28.5z M19,28.5V21h-7.5v7.5H19z M28.5,11.5H21V19h7.5V11.5z M11.5,19H19
			v-7.5h-7.5V19z M28.5,9.5V2H21v7.5H28.5z M30.5,11.5V19H38v-7.5H30.5z M38,9.5V3c0-0.5-0.5-1-1-1h-6.5v7.5H38z M19,9.5V2h-7.5v7.5
			H19z M30.5,38H37c0.5,0,1-0.5,1-1V21h-7.5V38z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Keypad
};
